export default __webpack_public_path__ + "static/media/magnifying-glass.73c98bef.svg";